import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterMatchEvent} from "@/modules/match/events/AfterMatchEvent";
import {AfterTransferEvent} from "@/modules/transfer-market/events/AfterTransferEvent";
import {TYPES} from "@/modules/archiements/types";
import {AchievementHandlerInterface} from "@/modules/archiements/interfaces";
import {AchievementTypeEnum} from "@/modules/archiements/enums";
import {MatchResultEnum} from "@/modules/base/enums";

@injectable()
export class AchievementsEventSubscriber implements EventSubscriber {
  constructor(
    @inject(TYPES.AchievementHandler) private achievementHandler: AchievementHandlerInterface,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterMatchEvent, callback: this.onAfterMatchEvent},
      {event: AfterTransferEvent, callback: this.onAfterBuyTransferEvent},
      {event: AfterTransferEvent, callback: this.onAfterSellTransferEvent},
    ];
  }

  async onAfterMatchEvent(event: AfterMatchEvent): Promise<void> {
    if (!event.match.homeTeam.user && !event.match.awayTeam.user) {
      return;
    }

    if (
      !(event.match.result === MatchResultEnum.HOME_WIN && event.match.homeTeam.user)
      && !(event.match.result === MatchResultEnum.AWAY_WIN && event.match.awayTeam.user)
    ) {
      return;
    }

    await this.achievementHandler.increase(AchievementTypeEnum.MATCH_WON, 1);
  }

  async onAfterBuyTransferEvent(event: AfterTransferEvent): Promise<void> {
    if (!event.team.user) {
      return;
    }

    await this.achievementHandler.setHighest(AchievementTypeEnum.PLAYER_BUY, event.price);
  }

  async onAfterSellTransferEvent(event: AfterTransferEvent): Promise<void> {
    if (!event.player.team || !event.player.team.user) {
      return;
    }

    await this.achievementHandler.setHighest(AchievementTypeEnum.PLAYER_SELL, event.price);
  }
}